(function () {
  'use strict';

  if (navigator.connection) {
    if (navigator.connection.saveData) return;
    if (/(2|slow-2)g/.test(navigator.connection.effectiveType || '')) return;
  }

  var prefetched = new Set();
  var EXCLUDE = /^\/(cart|checkout|account|admin|policies|services|apps|search|tools|password|challenge)(\/|$)/i;

  function resolve(href) {
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return null;
      if (u.pathname === location.pathname) return null;
      if (EXCLUDE.test(u.pathname)) return null;
      if (u.search) return null;
      var clean = u.origin + u.pathname;
      return prefetched.has(clean) ? null : clean;
    } catch (e) {
      return null;
    }
  }

  function prefetch(href) {
    var clean = resolve(href);
    if (!clean) return;
    prefetched.add(clean);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = clean;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function onIntent(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (a) prefetch(a.href);
  }

  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent, true);
})();
